import { render, staticRenderFns } from "./pnldim1.vue?vue&type=template&id=667a4706"
import script from "./pnldim1.vue?vue&type=script&lang=js"
export * from "./pnldim1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports